export enum EnumCRT {
    SIMPLES_NACIONAL = 1,
    SIMPLES_NACIONAL_EXCESSO = 2,
    REGIME_NORMAL = 3,
    DEFAULT = 0
}